import React from 'react';
import './index.css';

const LTLayout = () => {
	return (
		<div id='lambda__header__wrapper'>
			<header className='main__header__placeholder'>
				<div className='header__top__menu__placeholder'>
					<div className='lambda__logo__wrapper__placeholder' />
				</div>
				<div className='header__aside__menu__placeholder' />
			</header>
		</div>
	);
};

export default LTLayout;
